import React, { useState, useEffect } from "react";

import { Box, Button, Chip, Menu, MenuItem } from "@mui/material";
import { ASS_STATUS } from "../constants/status";

const EditableChipCell = ({ value, id, onChange, name }) => {
  const [anchorEl, setAnchorEl] = useState(null); // 상태를 null로 초기화
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (link) => {
    setLocalValue(link);
    onChange(name, link, id);
    handleClose();
  };
  return (
    <Box sx={{ width: "8.33%" }}>
      <Button onClick={handleClick}>
        <Chip
          label={ASS_STATUS[localValue].message}
          color={ASS_STATUS[localValue].color}
        />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {Object.keys(ASS_STATUS).map((link, index) => (
          <MenuItem key={index} onClick={() => handleChange(link)}>
            <Chip
              label={ASS_STATUS[link].message}
              color={ASS_STATUS[link].color}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default EditableChipCell;
